import { LogSeverity, StepExecutionLogs, StepRunConditionalRoute } from '@/types/stepExecutions.ts';

// Presentation-only fallback for historical runs without readable Activity.
// Unused branch configuration does not belong in the default execution story.
export const getConditionalActivityFallback = (
  routes: StepRunConditionalRoute[],
): StepExecutionLogs =>
  routes.flatMap((route) => {
    const evaluation =
      route.evaluation === 'matched'
        ? 'matched'
        : route.evaluation === 'not_matched'
          ? 'did not match'
          : null;
    if (!route.selected && !evaluation && !route.decision_dataset) return [];
    // Names are configuration labels, not Markdown authored for Activity.
    const name = route.name.replace(/[\\`*_[\]<>~&]/g, '\\$&');
    const message = evaluation
      ? `Condition '${name}' ${evaluation}${route.selected ? '; branch selected' : ''}.`
      : route.selected
        ? `Branch '${name}' selected; condition result unavailable.`
        : `Condition result unavailable for '${name}'.`;
    return [
      {
        id: `conditional-route-${route.condition_id}`,
        is_internal: false,
        created_at: '',
        message,
        detail_message: route.justification ?? '',
        severity: LogSeverity.Info,
        event_kind: null,
        dataset: route.decision_dataset,
        extract_entity_prefix: null,
        extract_entity_id: null,
      },
    ];
  });
